import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from '@app/interfaces';
// import { environment } from '@environments/environment';


/** 
https://jasonwatmore.com/post/2018/05/23/angular-6-jwt-authentication-example-tutorial
https://jasonwatmore.com/post/2020/07/09/angular-10-jwt-authentication-example-tutorial
*/
@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(username: string, password: string) {
        const apiUrl = '' // environment.apiUrl;
        return this.http.post<any>(`${apiUrl}/users/authenticate`, { username, password })
            .pipe(map(this.setCurrentUser));
    }


    setCurrentUser(user: User) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('currentUser', JSON.stringify(user));
        this.currentUserSubject.next(user);
        return user;
    }

    setUserData(userData) {
      const { id, username, firstName,lastName, partnerId } = userData.user;
      var user: User = {
        id, username, firstName, lastName,
        token: userData.access_token
      }
      return this.setCurrentUser(user);
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }
}